import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";

import type { TAddressRequestParams, TNewAddressForm } from "../types";
import mapNewAddressToRequestParams from "../utils/mapNewAddressToRequestParams";
import mapNewResponseErrorsToFields from "../utils/mapNewResponseErrorsToFields";

type TNewAddressReturn = {
  id: string;
};

const createAddressBookEntry = createApiService<TNewAddressReturn, TAddressRequestParams>({
  url: API_ROUTES.ADDRESS_BOOK,
  method: "POST",
  allowedErrStatus: [409, 422],
});

const saveAddressBookEntry = async (
  form: Partial<TNewAddressForm>,
  isLocker: boolean
): Promise<TServiceReturns<TNewAddressReturn, TNewAddressForm>> => {
  // At this point data is valid
  const data = mapNewAddressToRequestParams(form as TNewAddressForm, isLocker);

  const response = await createAddressBookEntry({ data });
  if (response.isSuccess) {
    return response;
  }

  return {
    ...response,
    isSuccess: false,
    errorMessage: response.errorMessage,
    errorDetails: mapNewResponseErrorsToFields(response.errorDetails || {}),
  };
};
export default saveAddressBookEntry;
